import clauseManagementSvg from "../assets/sidebar/clauseManagement.svg";
import clauseManagementSelectedSvg from "../assets/sidebar/clauseManagement_selected.svg";
import contractManagementSvg from "../assets/sidebar/contract.svg";

import dashboardNewSvg from "../assets/images/dashboardNewInactive.svg";
import dashboardNewSelected from "../assets/images/dashboardNewActive.svg";
import redliningSvg from "../assets/images/redliningNewInactive.svg";
import redliningSelectedSvg from "../assets/images/redliningNewActive.svg";
import clauseCheckSvg from "../assets/images/clauseCheckNewInactive.svg";
import clauseCheckSelectedSvg from "../assets/images/clauseCheckNewActive.svg";
import ttcSvg from "../assets/talk_to_contract_sidebar.svg";
import kccSvg from "../assets/key_contract_clause_sidebar.svg";
import breathingDashboardSvg from "../assets/breathing_dashboard_sidebar.svg";
import contractRedliningSvg from "../assets/contract_redlining.svg";
import contractDraftingDashboardSidebarSvg from "../assets/contract_drafting_dashboard_sidebar.svg";

import adminPanelSvg from "../assets/images/adminPanel.svg";
import accessNeededSvg from "../assets/access_needed.svg";
import submittedApprovedSvg from "../assets/request_submitted_approved.svg";
import bulkUploadSvg from "../assets/sidebar/bulkUpload.svg";
import clauseSummarySvg from "../assets/sidebar/clauseSummary.svg";
import userManagementSvg from "../assets/sidebar/manage_accounts.svg";
import userManagementSelectedSvg from "../assets/sidebar/manage_accounts_selected.svg";
import verticalManagementSvg from "../assets/sidebar/Vector.svg";
import Error404SVG from "../assets/images/Error404.svg";
import PdfIcon from "../assets/pdfIcon.svg";
import DocIcon from "../assets/docIcon.svg";

import { IAccessRequestState, SidebarOption, UploadConfig } from "./types";
import { UserRolesKey } from "../modules/Admin/constants";
import { ErrorCode } from "react-dropzone";
import usageAnalyticsSvg from "../assets/usage_Analytics_svg.svg";
import aboutSvg from "../assets/sidebar/about.svg";
import aboutSelectedSvg from "../assets/sidebar/about_selected.svg";
import dashboardGridSvg from "../assets/sidebar/dashboard.svg";
import dashboardGridSelectedSvg from "../assets/sidebar/dashboard_selected.svg";

export const VscDashboards = [
  {
    text: "VSC Dashboard Risk",
    disabled: false,
  },
];

export const FILE_UPLOAD_ERRORS = {
  DOC_FILE_SUPPORT_ONLY: "Allowed types include only .docx file. ",
  EXCEEDS_SIZE_CANNOT_EXCEED_10MB: "File size exceeds 10MB. ",
  NUMBER_OF_FILES_LIMIT_REACHED: "You can only upload upto 50 files. ",
  ONLY_PDFS_ARE_SUPPORTED: "Only PDF files are supported. ",
  PDF_IS_NOT_SUPPORTED: "PDF files are not supported. ",
};

//10 MB
export const FILE_SIZE_LIMIT_10_MB = 10 * 1024 * 1024;

export const FILES_LIMIT_FROM_DRIVE_UPLOAD = 50;

export const MimeTypes = {
  gDoc: "application/vnd.google-apps.document",
  gFolder: "application/vnd.google-apps.folder",
  gFile: "application/vnd.google-apps.file",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  zip: "application/zip",
  txt: "text/plain",
  csv: "text/csv",
  word: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

export const avatarStyleForCount = {
  primary: {
    border: "1px solid #E6A800",
    color: "#E6A800",
    background: "#E6A8000D",
  },
  nonPrimary: {
    border: "1px solid #0E9D58",
    color: "#0E9D58",
    background: "#0E9D580D",
  },
};

export const staticFileComments = {
  review_comments: [
    {
      suggestion:
        "Specify that Earn Back is only applicable if minimum service levels for all other services are met.",
      document_content:
        "Earn Backs. An Earn Back will be applicable if Supplier meets or exceeds Target Service Levels",
      section: "Section 1.6. Earn Backs",
      page_number: "42",
    },
    {
      suggestion:
        "Clarify the credit cap percentage and ensure it does not exceed 10% as per the rule.",
      document_content:
        "The Credit Cap for each Order Form is 5% of the monthly professional Services fees thereunder.",
      section: "Section 2.1. Credits Cap",
      page_number: "43",
    },
    {
      suggestion:
        "Include a requirement for quarterly assessment and a plan for productivity improvement for workflows with less than 10 personnel.",
      document_content:
        "In any Order Form, the parties may mutually agree to specific bench requirements.",
      section: "N/A",
      page_number: "8",
    },
    {
      suggestion:
        "Add a clause addressing productivity improvements for contracts exceeding 12 months, starting 1 year from the SOW Effective Date.",
      document_content:
        "During the SOW Term, Supplier will become increasingly proficient in its performance of the Services. As a result, Supplier will provide at least 5% productivity improvements year over year measured as which may include either: reduced Supplier Staff or fees for the same volume; or, the same Supplier Staff for a higher volume of services or savings as mutually agreed between both parties. Supplier may drive price productivity through a combination of higher offshoring, right shoring, proficiency, automation, tools, and process engineering.",
      section: "Productivity Improvements",
      page_number: "9",
    },
    {
      suggestion:
        "Incorporate a clause to track and document productivity metrics (staff numbers, fees, service volumes).",
      document_content:
        "During the SOW Term, Supplier will become increasingly proficient in its performance of the Services. As a result, Supplier will provide at least 5% productivity improvements year over year measured as which may include either: reduced Supplier Staff or fees for the same volume; or, the same Supplier Staff for a higher volume of services or savings as mutually agreed between both parties. Supplier may drive price productivity through a combination of higher offshoring, right shoring, proficiency, automation, tools, and process engineering.",
      section: "Productivity Improvements",
      page_number: "9",
    },
  ],
  reviewed_pdf_file_name: "MSOW 2_reviewed.pdf",
  reviewed_document_file_name: "MSOW 2_reviewed.docx",
};

export const PROTECTED = "PROTECTED";

export const LOCAL_STORAGE_KEYS = {
  USER_META_DATA: "USER_META_DATA",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  GOOGLE_AUTH_TOKEN: "GOOGLE_AUTH_TOKEN",
  GOOGLE_ACCESS_TOKEN: "GOOGLE_ACCESS_TOKEN",
  GOOGLE_REFRESH_TOKEN: "GOOGLE_REFRESH_TOKEN",
  VERTICALS: "VERTICALS",
};

export const TIMEOUT_MILLISECONDS = 60 * 60 * 1000;
export const GENERAL_DEBOUNCE_TIME = 500;
export const SECONDS_TO_REFRESH_TOKEN = 30;
export const REFRESH_USER_DETAILS_INTERVAL = 60 * 1000;
// If fetchProfileDataThunk fails this many times in a row, AuthContainer
// forces a clean logout rather than leaving a blank home/sidebar with no
// way to recover.
export const MAX_CONSECUTIVE_PROFILE_FETCH_FAILURES = 3;
// While a failure is being counted toward the threshold above, retry at
// this (fast) cadence instead of waiting for the next REFRESH_USER_DETAILS_INTERVAL
// tick — a dead session should be detected and resolved in seconds, not
// the ~minutes a 60s-spaced count would otherwise take.
export const PROFILE_FETCH_RETRY_INTERVAL_MS = 5 * 1000;
// Minimum time between /version.json checks (see useVersionCheck) — checks
// are triggered by tab focus/visibility, not a timer, this just debounces
// rapid tab-switching.
export const VERSION_CHECK_MIN_INTERVAL_MS = 5 * 60 * 1000;

const syncContracts = "sync_contracts";
const syncContractsJob = "sync_contracts_job";
const batchDetails = "kcc_batch_job";
const verticalDetails = "vertical_details";
const jobDetails = "job_details";

export const ROUTES = {
  dashboard: "/",
  login: "/login",
  doc: "/doc",
  manageContracts: "/manage-contract",
  contractDraft: "/contract-draft",
  bulkClauseCheck: "/bulk-clause-check",
  clauseSummary: "/clause-summary",
  profile: "/profile",
  adminDashboard: "/admin-dashboard",
  verticalManagement: "/vertical-management",
  verticalManagementDetails: `/${verticalDetails}/:verticalId`,
  jobDetails: `/${jobDetails}/:jobId`,
  clauseCheckDoc: "/clause-check-doc",
  clauseManagement: "/clause-management",
  clauseManagementContractReview: "/clause-management/contract-review",
  clauseManagementKcc: "/clause-management/key-contract-clauses",
  paConfiguration: "/pa-configuration",
  contractManagement: "/contract-management",
  manageRole: "/manage-role",
  moduleManagement: "/module-management",
  dashboardTabs: "/dashboard",
  ttcDashboard: "/dashboard?cardType=ttc",
  ttcAgenticDashboard: "/dashboard?cardType=ttc_agentic",
  contractReviewDashboard: "/dashboard?cardType=contract_review",
  contractDraftDashboard: "/dashboard?cardType=contract_draft_requests",
  contractDraftDetail: "/contract-draft/:requestId",
  keyContractClausesDashboard: "/dashboard?cardType=clause_check",
  keyContractClausesDashboardAdvanced:
    "/dashboard?cardType=clause_check_advanced",
  keyContractClausesDashboardAdvancedDetails: `/${batchDetails}/:batch_id/vertical/:vertical_id`,
  keyContractClausesDashboardAgentic:
    "/dashboard?cardType=clause_check_agentic",
  dueContractsDashboard: "/dashboard?cardType=breathing_dashboard",
  usageAnalyticsDashboard: "/dashboard?cardType=usage_analytics",
  contractExecutionDashboard: "/dashboard?cardType=contract_execution",
  syncContractsDashboard: `/${syncContracts}/`,
  syncContractsDetailsDashboard: `/${syncContractsJob}/:sync_job_id/vertical/:vertical_id`,
  taskOrderExtractionDashboard: "/task-order-extraction",
  completeReviewsRedlining: `/manage-contract?url=review_completed`,
  pendingReviewsRedlining: `/manage-contract?url=review_pending`,
  pdfViewer: "/pdf-viewer",
  about: "/about",
  reports: "/reports",
  error: "*",
};

// External Looker Studio (formerly Google Data Studio) report links.
// Not yet integrated into Orbit's own data layer — this is a simple
// launcher page until/unless these get pulled in natively.
export const EXTERNAL_REPORT_LINKS = [
  {
    title: "EVM SLA",
    url: "https://datastudio.google.com/c/reporting/1054d7fa-4fcd-4f25-bb91-be0f77cb8dae/page/p_eg15zpoe5d",
  },
  {
    title: "VM Portfolio Dashboard",
    url: "https://datastudio.google.com/c/reporting/2e5d7b11-f9a2-456c-9582-22b24eb16a74/page/p_b3awqavv4d",
  },
  {
    title: "VM Team Tasks Dashboard",
    url: "https://datastudio.google.com/c/reporting/74acbfdd-5211-4dfb-a4c7-6b6756d5a1c7/page/p_ggahpu0ord",
  },
  {
    title: "Cloud VMO Eng Data",
    url: "https://datastudio.google.com/c/reporting/3fa13d5b-3791-4d79-9927-69376fd84d63/page/p_i5e06ifu0d",
  },
];

export const MODULE_ACCESS = {
  CONTRACT_REVIEW: "contract_review",
  CLAUSE_CHECK: "clause_check",
  CONTRACT_DRAFTING: "contract_drafting",
  TALK_TO_CONTRACT: "talk_to_contract",
  BREATHING_DASHBOARD: "breathing_dashboard",
  USER_MANAGEMENT: "user_management",
  CONTRACT_REVIEW_CLAUSE_MANAGEMENT: "contract_review_clause_management",
  KCC_CLAUSE_MANAGEMENT: "kcc_clause_management",
  CONTRACT_MANAGEMENT: "contract_management",
  VERTICAL_MANAGEMENT: "vertical_management",
  CONTRACT_REPOSITORY: "contract_repository",
  USAGE_METRICS: "usage_metrics",
  MODULE_MANAGEMENT: "module_management",
  REPORTS: "reports",
  TASK_ORDER_EXTRACTION: "task_order_extraction",
};

export const AVAILABLE_MODULES = [
  MODULE_ACCESS.CONTRACT_REVIEW,
  MODULE_ACCESS.CLAUSE_CHECK,
  MODULE_ACCESS.CONTRACT_DRAFTING,
  MODULE_ACCESS.TALK_TO_CONTRACT,
  MODULE_ACCESS.USER_MANAGEMENT,
  MODULE_ACCESS.CONTRACT_REVIEW_CLAUSE_MANAGEMENT,
  MODULE_ACCESS.KCC_CLAUSE_MANAGEMENT,
  MODULE_ACCESS.CONTRACT_MANAGEMENT,
  MODULE_ACCESS.VERTICAL_MANAGEMENT,
  MODULE_ACCESS.CONTRACT_REPOSITORY,
  MODULE_ACCESS.USAGE_METRICS,
  MODULE_ACCESS.MODULE_MANAGEMENT,
  MODULE_ACCESS.REPORTS,
  MODULE_ACCESS.TASK_ORDER_EXTRACTION,
];

export const INTERNAL_MODULES = [
  MODULE_ACCESS.USER_MANAGEMENT,
  MODULE_ACCESS.CONTRACT_REVIEW_CLAUSE_MANAGEMENT,
  MODULE_ACCESS.KCC_CLAUSE_MANAGEMENT,
  MODULE_ACCESS.CONTRACT_MANAGEMENT,
  MODULE_ACCESS.VERTICAL_MANAGEMENT,
  MODULE_ACCESS.MODULE_MANAGEMENT,
];

export const ASSIGNABLE_MODULES = [
  MODULE_ACCESS.CONTRACT_REPOSITORY,
  MODULE_ACCESS.TALK_TO_CONTRACT,
  MODULE_ACCESS.CLAUSE_CHECK,
  MODULE_ACCESS.BREATHING_DASHBOARD,
  MODULE_ACCESS.CONTRACT_DRAFTING,
  MODULE_ACCESS.CONTRACT_REVIEW,
  MODULE_ACCESS.USAGE_METRICS,
  MODULE_ACCESS.REPORTS,
  MODULE_ACCESS.TASK_ORDER_EXTRACTION,
];

export const MODULE_DISPLAY_NAMES: Record<string, string> = {
  [MODULE_ACCESS.CONTRACT_REVIEW]: "Contract Review",
  [MODULE_ACCESS.CLAUSE_CHECK]: "Key Contract Clauses",
  [MODULE_ACCESS.CONTRACT_DRAFTING]: "Contract Drafting",
  [MODULE_ACCESS.TALK_TO_CONTRACT]: "Talk To Contract",
  [MODULE_ACCESS.BREATHING_DASHBOARD]: "Breathing Dashboard",
  [MODULE_ACCESS.CONTRACT_REPOSITORY]: "Contract Repository",
  [MODULE_ACCESS.USAGE_METRICS]: "Usage Metrics",
  [MODULE_ACCESS.USER_MANAGEMENT]: "User Management",
  [MODULE_ACCESS.CONTRACT_REVIEW_CLAUSE_MANAGEMENT]:
    "Contract Review Clause Management",
  [MODULE_ACCESS.KCC_CLAUSE_MANAGEMENT]:
    "Key Contract Clauses Clause Management",
  [MODULE_ACCESS.CONTRACT_MANAGEMENT]: "Contract Management",
  [MODULE_ACCESS.VERTICAL_MANAGEMENT]: "Vertical Management",
  [MODULE_ACCESS.MODULE_MANAGEMENT]: "Feature Management",
  [MODULE_ACCESS.REPORTS]: "VMO Dashboards",
  [MODULE_ACCESS.TASK_ORDER_EXTRACTION]: "Task Order Extraction",
};

export const MANAGEMENT_MODULE_DEPENDENCIES: Record<string, string[]> = {
  [MODULE_ACCESS.USER_MANAGEMENT]: [MODULE_ACCESS.USER_MANAGEMENT],
  [MODULE_ACCESS.CONTRACT_REVIEW_CLAUSE_MANAGEMENT]: [
    MODULE_ACCESS.CONTRACT_REVIEW,
    MODULE_ACCESS.CONTRACT_DRAFTING,
  ],
  [MODULE_ACCESS.KCC_CLAUSE_MANAGEMENT]: [MODULE_ACCESS.CLAUSE_CHECK],
  [MODULE_ACCESS.CONTRACT_MANAGEMENT]: [MODULE_ACCESS.CONTRACT_DRAFTING],
  [MODULE_ACCESS.VERTICAL_MANAGEMENT]: [
    MODULE_ACCESS.CONTRACT_REPOSITORY,
    MODULE_ACCESS.TALK_TO_CONTRACT,
    MODULE_ACCESS.CLAUSE_CHECK,
    MODULE_ACCESS.BREATHING_DASHBOARD,
    MODULE_ACCESS.CONTRACT_DRAFTING,
    MODULE_ACCESS.CONTRACT_REVIEW,
  ],
  [MODULE_ACCESS.MODULE_MANAGEMENT]: [MODULE_ACCESS.MODULE_MANAGEMENT],
};

export const CLAUSE_MANAGEMENT_VISIBLE_MODULES = [
  ...MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.CONTRACT_REVIEW_CLAUSE_MANAGEMENT],
  ...MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.KCC_CLAUSE_MANAGEMENT],
];

export const CLAUSE_MANAGEMENT_TAB_DEPENDENCIES = [
  {
    text: "Contract Review",
    moduleNames: [MODULE_ACCESS.CONTRACT_REVIEW, MODULE_ACCESS.CONTRACT_DRAFTING],
  },
  {
    text: MODULE_DISPLAY_NAMES[MODULE_ACCESS.CLAUSE_CHECK],
    moduleNames: [MODULE_ACCESS.CLAUSE_CHECK],
  },
];

export const breadCrumbData = {
  dashboard: { text: "Dashboard", link: ROUTES.dashboard },
  contractReviewDashboard: {
    text: "Contract Review",
    link: ROUTES.contractReviewDashboard,
  },
  keyContractClausesDashboard: {
    text: "Key Contract Clauses",
    link: ROUTES.keyContractClausesDashboard,
  },
  manageContracts: {
    text: "All Contracts",
    link: ROUTES.manageContracts,
  },
  contractDraft: {
    text: "Contract Draft",
    link: ROUTES.contractDraft,
  },
  bulkUpload: {
    text: "Bulk Upload",
    link: ROUTES.bulkClauseCheck,
  },

  clauseSummary: {
    text: "Clause Summary",
    link: ROUTES.clauseSummary,
  },

  profile: {
    text: "Profile",
    link: ROUTES.profile,
  },

  userManagment: {
    text: "User Managment",
    link: ROUTES.adminDashboard,
  },

  clauseManagement: {
    text: "Clause Management",
    link: ROUTES.clauseManagementContractReview,
  },

  contractManagement: {
    text: "Contract Management",
    link: ROUTES.contractManagement,
  },

  manageRole: {
    text: "Manage Role",
    link: ROUTES.manageRole,
  },

  contractReview: {
    text: "Contract Redlining",
    // link: ROUTES.manageRole,
  },

  // contractRedliningDashboard: {
  //   text: "Contract Redlining",
  //   // link: ROUTES.dashboardTabs + "?cardType=" + LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining,
  // },

  clausesDashboard: {
    text: "Key Contract Clauses",
    // link: ROUTES.dashboardTabs + "?cardType=" + LANDING_PAGE_TO_DASHBOARD_URLS.clause_check,
  },
  dueContractsDashboard: {
    text: "Due Contracts",
    link: ROUTES.dueContractsDashboard,
  },
  clauseCheckAgenticDashboard: {
    text: "Key Contract Clauses - Agentic",
    link: ROUTES.keyContractClausesDashboardAgentic,
  },
  usageAnalyticsDashboard: {
    text: "Usage Analytics",
    link: ROUTES.usageAnalyticsDashboard,
  },
  contractExecutionDashboard: {
    text: "Contract Repository",
    link: ROUTES.contractExecutionDashboard,
  },
  pendingReviewsRedlining: {
    text: "All Contracts",
    link: ROUTES.pendingReviewsRedlining,
  },
  completeReviewsRedlining: {
    text: "All Contracts",
    link: ROUTES.completeReviewsRedlining,
  },
};

export const sidebarContent: SidebarOption = {
   dashboard: {
    active: dashboardNewSelected,
    inactive: dashboardNewSvg,
    title: "Dashboard",
    url: ROUTES.dashboard,
    supportUrls: [ROUTES.dashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
  contractExecution: {
    active: clauseSummarySvg,
    inactive: clauseSummarySvg,
    title: "Contract Repository",
    url: ROUTES.contractExecutionDashboard,
    supportUrls: [ROUTES.contractExecutionDashboard],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.REDLINING_USER],
    moduleName: MODULE_ACCESS.CONTRACT_REPOSITORY,
    queryParams: ["cardType=contract_execution"],
    isLive: false,
  },
  agenticTTC: {
    active: ttcSvg,
    inactive: ttcSvg,
    title: "Talk To Contract",
    url: ROUTES.ttcAgenticDashboard,
    supportUrls: [ROUTES.ttcAgenticDashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
    moduleName: MODULE_ACCESS.TALK_TO_CONTRACT,
    queryParams: ["cardType=ttc_agentic", "session"],
    isLive: false,
  },
  kccAgentic: {
    active: kccSvg,
    inactive: kccSvg,
    title: "Key Contract Clauses",
    url: ROUTES.keyContractClausesDashboardAgentic,
    supportUrls: [ROUTES.keyContractClausesDashboardAgentic],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.CLAUSE_CHECK_USER],
    moduleName: MODULE_ACCESS.CLAUSE_CHECK,
    isLive: false,
  },
  breathingDashboard: {
    active: breathingDashboardSvg,
    inactive: breathingDashboardSvg,
    title: "Breathing Dashboard",
    url: ROUTES.dueContractsDashboard,
    supportUrls: [ROUTES.dueContractsDashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
    moduleName: MODULE_ACCESS.BREATHING_DASHBOARD,
    isLive: false,
  },
  contractDraftDashboard: {
    active: contractDraftingDashboardSidebarSvg,
    inactive: contractDraftingDashboardSidebarSvg,
    title: "Contract Drafting",
    url: ROUTES.contractDraftDashboard,
    supportUrls: [ROUTES.contractDraftDashboard],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.REDLINING_USER],
    moduleName: MODULE_ACCESS.CONTRACT_DRAFTING,
    isLive: false,
  },
  taskOrderExtraction: {
    active: bulkUploadSvg,
    inactive: bulkUploadSvg,
    title: "Task Order Extraction",
    url: ROUTES.taskOrderExtractionDashboard,
    supportUrls: [ROUTES.taskOrderExtractionDashboard],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.REDLINING_USER],
    moduleName: MODULE_ACCESS.TASK_ORDER_EXTRACTION,
    isLive: false,
  },
  contract: {
    active: contractRedliningSvg,
    inactive: contractRedliningSvg,
    title: "Contract Review",
    url: ROUTES.manageContracts,
    supportUrls: [ROUTES.manageContracts, ROUTES.contractReviewDashboard],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.REDLINING_USER],
    moduleName: MODULE_ACCESS.CONTRACT_REVIEW,
    isLive: false,
  },
  usageAnalytics: {
    active: usageAnalyticsSvg,
    inactive: usageAnalyticsSvg,
    title: "Usage Metrics",
    url: ROUTES.usageAnalyticsDashboard,
    supportUrls: [ROUTES.usageAnalyticsDashboard],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.USER, UserRolesKey.REDLINING_USER],
    moduleName: MODULE_ACCESS.USAGE_METRICS,
    queryParams: ["cardType=usage_analytics"],
    isLive: false,
  },
  reports: {
    active: dashboardGridSelectedSvg,
    inactive: dashboardGridSvg,
    title: "VMO Dashboards",
    url: ROUTES.reports,
    supportUrls: [ROUTES.reports],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
    moduleName: MODULE_ACCESS.REPORTS,
  },
  admin: {
    active: adminPanelSvg,
    inactive: adminPanelSvg,
    title: "Manage",
    url: ROUTES.bulkClauseCheck,
    supportUrls: [
      ROUTES.adminDashboard,
      ROUTES.clauseManagement,
      ROUTES.clauseManagementContractReview,
      ROUTES.clauseManagementKcc,
      ROUTES.contractManagement,
      ROUTES.verticalManagement,
      ROUTES.moduleManagement,
    ],
    showFor: [UserRolesKey.ADMIN, UserRolesKey.POWER_USER],
    moduleName: [
      MODULE_ACCESS.USER_MANAGEMENT,
      ...CLAUSE_MANAGEMENT_VISIBLE_MODULES,
      ...MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.CONTRACT_MANAGEMENT],
      ...MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.VERTICAL_MANAGEMENT],
      MODULE_ACCESS.MODULE_MANAGEMENT,
    ],
    childNavs: [
      {
        title: "User Management",
        url: ROUTES.adminDashboard,
        supportUrls: [ROUTES.manageRole],
        showFor: [UserRolesKey.ADMIN],
        moduleName: MODULE_ACCESS.USER_MANAGEMENT,
        active: userManagementSvg,
      },
      {
        title: "Clause Management",
        url: ROUTES.clauseManagementContractReview,
        supportUrls: [
          ROUTES.clauseManagement,
          ROUTES.clauseManagementContractReview,
          ROUTES.clauseManagementKcc,
        ],
        showFor: [UserRolesKey.ADMIN],
        moduleName: CLAUSE_MANAGEMENT_VISIBLE_MODULES,
        active: clauseManagementSvg,
      },
      {
        title: "Contract Management",
        url: ROUTES.contractManagement,
        supportUrls: [ROUTES.contractManagement],
        showFor: [UserRolesKey.ADMIN],
        moduleName: MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.CONTRACT_MANAGEMENT],
        active: contractManagementSvg,
      },
      {
        title: "Vertical Management",
        url: ROUTES.verticalManagement,
        supportUrls: [ROUTES.verticalManagement],
        showFor: [UserRolesKey.ADMIN],
        moduleName: MANAGEMENT_MODULE_DEPENDENCIES[MODULE_ACCESS.VERTICAL_MANAGEMENT],
        active: verticalManagementSvg,
      },
      {
        title: "Feature Management",
        url: ROUTES.moduleManagement,
        supportUrls: [ROUTES.moduleManagement],
        showFor: [UserRolesKey.POWER_USER],
        moduleName: MODULE_ACCESS.MODULE_MANAGEMENT,
        active: userManagementSvg,
      },
    ],
  },
  about: {
    active: aboutSelectedSvg,
    inactive: aboutSvg,
    title: "About Us",
    url: ROUTES.about,
    supportUrls: [ROUTES.about],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
};

export const sideBarContentForAdmin: SidebarOption = {
  dashboard: {
    active: dashboardNewSelected,
    inactive: dashboardNewSvg,
    title: "Dashboard",
    url: ROUTES.dashboard,
    supportUrls: [ROUTES.dashboard],
    showFor: [
      UserRolesKey.ADMIN,
      UserRolesKey.USER,
      UserRolesKey.REDLINING_USER,
      UserRolesKey.CLAUSE_CHECK_USER,
    ],
  },
  userManagement: {
    active: userManagementSelectedSvg,
    inactive: userManagementSvg,
    url: ROUTES.adminDashboard,
    supportUrls: [ROUTES.manageRole],
    title: "User Management",
    showFor: [UserRolesKey.ADMIN],
  },
  clauseManagement: {
    active: clauseManagementSelectedSvg,
    inactive: clauseManagementSvg,
    url: ROUTES.clauseManagementContractReview,
    supportUrls: [ROUTES.clauseManagementContractReview],
    title: "Contract Review Clause Management",
    showFor: [UserRolesKey.ADMIN],
  },
  keyContractClausesClauseManagement: {
    active: clauseManagementSelectedSvg,
    inactive: clauseManagementSvg,
    url: ROUTES.clauseManagementKcc,
    supportUrls: [ROUTES.clauseManagementKcc],
    title: "Key Contract Clauses Clause Management",
    showFor: [UserRolesKey.ADMIN],
  },
  VerticalManagement: {
    active: verticalManagementSvg,
    inactive: verticalManagementSvg,
    url: ROUTES.verticalManagement,
    supportUrls: [ROUTES.manageRole],
    title: "Vertical Management",
    showFor: [UserRolesKey.ADMIN],
  },
};

export const USER_ROLES = {
  RISK: "Vendor Solutions Consultant - Risk",
  CONTRACT: "Vendor Solutions Consultant - Contracts",
};

export const DASHBOARD_ENTITIES = {
  TALK_TO_CONTRACT: "talkToContract",
  CONTRACT_REVIEW: "contractReview",
  CLAUSE_CHECK: "clauseCheck",
  CLAUSE_CHECK_ADVANCED: "clauseCheckAdvanced",
  CONTRACT_DRAFTING: "contractDrafting",
  RFX_EVALUATION: "rfxEvaluation",
  RFX_GENERATOR: "rfxGenerator",
  SYNC_CONTRACTS: "syncContracts",
  USAGE_ANALYTICS: "usageAnalytics",
};

export const TTC_MAX_REFERENCE_FILES = 5;

export const FORBIDDEN_FILE_TYPES = [
  ErrorCode.FileTooLarge,
  ErrorCode.FileInvalidType,
];

export const UploadDocConfig: UploadConfig = {
  [DASHBOARD_ENTITIES.CONTRACT_REVIEW]: {
    maxFilesNumber: 1,
    multiple: false,
    disabled: false,
    accept: {
      [MimeTypes.doc]: [".doc"],
      [MimeTypes.docx]: [".docx"],
      [MimeTypes.gDoc]: [],
    },
    driveMultiSelect: false,
    maxSize: FILE_SIZE_LIMIT_10_MB,
    driveMimeTypes: [MimeTypes.doc, MimeTypes.docx, MimeTypes.gDoc].join(","),
    allowedFileTypeText: "DOC",
    allowedFileSizeLimit: "10MB",
    fileSizeWarningText: "Do not upload files larger than 10 MB.",
    docTypeWarningText: "Files uploaded are restricted to DOC format only.",
    noDrag: false,
    fileTypeAndSizeWarningText: "Upload only DOC files with size upto 10MB.",
    alreadyExistsText:
      "File is already uploaded. Please remove it to continue.",
    alreadySelectedText:
      "File already in selection. Please remove duplicate to continue.",
    fileTypeWarningText: "Files restricted to DOC format only.",
  },
  [DASHBOARD_ENTITIES.CLAUSE_CHECK]: {
    maxFilesNumber: 15,
    multiple: true,
    disabled: false,
    accept: {
      [MimeTypes.pdf]: [".pdf"],
    },
    driveMultiSelect: true,
    maxSize: FILE_SIZE_LIMIT_10_MB,
    driveMimeTypes: [MimeTypes.pdf, MimeTypes.gFile, MimeTypes.gFolder].join(
      ","
    ),
    allowedFileTypeText: "PDF",
    allowedFileSizeLimit: "10MB",
    fileSizeWarningText: "Do not upload files larger than 10 MB.",
    docTypeWarningText: "Files uploaded are restricted to PDF format only.",
    noDrag: false,
    fileTypeAndSizeWarningText: "Upload only PDF files with size upto 10MB.",
    alreadyExistsText:
      "File is already uploaded. Please remove it to continue.",
    alreadySelectedText:
      "File already in selection. Please remove duplicate to continue.",
    isUnifiedUploadSupported: true,
    fileTypeWarningText: "Files restricted to PDF format only.",
  },
  [DASHBOARD_ENTITIES.CLAUSE_CHECK_ADVANCED]: {
    maxFilesNumber: 15,
    multiple: true,
    disabled: false,
    accept: {
      [MimeTypes.pdf]: [".pdf"],
    },
    driveMultiSelect: true,
    maxSize: FILE_SIZE_LIMIT_10_MB,
    driveMimeTypes: [MimeTypes.pdf, MimeTypes.gFile, MimeTypes.gFolder].join(
      ","
    ),
    allowedFileTypeText: "PDF",
    allowedFileSizeLimit: "10MB",
    fileSizeWarningText: "Do not upload files larger than 10 MB.",
    docTypeWarningText: "Files uploaded are restricted to PDF format only.",
    noDrag: false,
    fileTypeAndSizeWarningText: "Upload only PDF files with size upto 10MB.",
    alreadyExistsText:
      "File is already uploaded. Please remove it to continue.",
    alreadySelectedText:
      "File/Folder already in selection. Please remove duplicate to continue.",
    isUnifiedUploadSupported: true,
    fileTypeWarningText: "Files restricted to PDF format only.",
    canSelectedFolder: true,
  },
  [DASHBOARD_ENTITIES.TALK_TO_CONTRACT]: {
    maxFilesNumber: 5,
    multiple: true,
    disabled: false,
    accept: {
      [MimeTypes.pdf]: [".pdf"],
    },
    driveMultiSelect: true,
    maxSize: FILE_SIZE_LIMIT_10_MB,
    driveMimeTypes: [MimeTypes.pdf, MimeTypes.gFile, MimeTypes.gFolder].join(
      ","
    ),
    allowedFileTypeText: "PDF",
    allowedFileSizeLimit: "10MB",
    fileSizeWarningText: "Do not upload files larger than 10 MB.",
    docTypeWarningText: "Files uploaded are restricted to PDF format only.",
    noDrag: false,
    fileTypeAndSizeWarningText: "Upload only PDF files with size upto 10MB.",
    alreadyExistsText:
      "File is already uploaded. Please remove it to continue.",
    alreadySelectedText:
      "File already in selection. Please remove duplicate to continue.",
    fileTypeWarningText: "Files restricted to PDF format only.",
  },
};

export const ErrorType = {
  NOT_FOUND: "not-found",
  ACCESS_DENIED: "access-denied",
};

export const ErrorConfig = {
  [ErrorType.NOT_FOUND]: {
    errorCode: 404,
    errorTitle: "That's an error",
    errorText: {
      prefix: "The Requested URL",
      suffix: "was not found on this server. Thats all we know.",
    },
    errorImg: Error404SVG,
  },
  [ErrorType.ACCESS_DENIED]: {
    errorCode: 403,
    errorTitle: "Access Denied",
    errorText: {
      prefix: "Seems Like you don't have access to this page.",
      suffix: "",
    },
    errorImg: Error404SVG,
  },
};

export const REMOVE_TOKENS = {
  LOCAL_STORAGE_KEYS: [
    LOCAL_STORAGE_KEYS.ACCESS_TOKEN,
    LOCAL_STORAGE_KEYS.REFRESH_TOKEN,
    LOCAL_STORAGE_KEYS.VERTICALS,
  ],
};

export const clauseCheckTableView = {
  OVERVIEW: "overview",
  SUMMARY: "summary",
};

export const ADMIN_CLAUSE_CHECK_ALERT_MESSAGES = {
  MAXIMUM_CLAUSE_ERROR_MESSAGE:
    "Maximum of 10 clauses can be enabled for a vertical",
  MINIMUM_CLAUSE_ERROR_MESSAGE:
    "Minimum 1 clauses should be enabled for a vertical",
  MINIMUM_CLAUSE_TO_BE_SELECTED_WHILE_IMPORTING:
    "Please select atleast 1 clause to import",
};

export const accessRequestState: IAccessRequestState = {
  raise_request: {
    title: "Access Needed",
    description: `You currently do not have access to Orbit. 
                 Please request the permissions to gain access.`,
    topImage: accessNeededSvg,
    requestAccessBtn: true,
  },
  request_raised: {
    title: "Your request has successfully been submitted!",
    description: `Thank you for submitting your request. You will receive a notification once it has been reviewed.
We appreciate your patience and understanding.`,
    topImage: submittedApprovedSvg,
  },
  request_under_review: {
    title: "Request Under Review",
    description: `We appreciate your patience. Your request is currently being reviewed by our team.
You will be notified when your request is approved.`,
    isLink: true,
    topImage: submittedApprovedSvg,
  },
  request_pending: {
    title: "Your Request is pending",
    description: `Your request is taking too long than usual to approve.`,
    topImage: accessNeededSvg,
    isLink: true,
  },
};

export const REQUEST_STATUS = {
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
  MANUALLY_ADDED: "manually_added",
};

export const activeUserStatus = [
  REQUEST_STATUS.APPROVED,
  REQUEST_STATUS.MANUALLY_ADDED,
];

export const GRAPH_COLOR_GRADIENTS = {
  PURPLE: [
    "#f3e5ff",
    "#dcb3ff",
    "#c580ff",
    "#ad4dff",
    "#961aff",
    "#7d00e6",
    "#6100b3",
    "#450080",
    "#2a004d",
    "#0e001a",
  ],
  GREEN: [
    "#ecf9ed",
    "#c5edca",
    "#9ee1a6",
    "#77d582",
    "#50c85f",
    "#37af45",
    "#2a8836",
    "#1e6126",
    "#123a17",
    "#061308",
  ],
  BLUE: [
    "#e6f3fe",
    "#b4dbfd",
    "#83c4fc",
    "#51acfa",
    "#1f94f9",
    "#067be0",
    "#0560ae",
    "#03447c",
    "#02294b",
    "#010e19",
  ],

  YELLOW: [
    "#fcfbe8",
    "#f7f2bb",
    "#f1e98e",
    "#ebe060",
    "#e6d733",
    "#ccbe19",
    "#9f9414",
    "#716a0e",
    "#443f08",
    "#171503",
  ],
};

export const DRIVE_LINK_ERRORS = {
  INVALID_URL: "Enter a valid URL",
  IS_REQUIRED: "Drive link is required.",
  INVALID_URL_EDIT:
    "Drive Link must be a valid URL and cannot be empty or 'N/A'.",
};
export const hiddenPagesForEnvironments = [
  "Key Contract Clauses",
  "Contract Redlining",
  "Breathing Dashboard",
];

export const getIconForFileMimeType = (mimeType: string) => {
  switch (mimeType) {
    case MimeTypes.pdf:
      return PdfIcon;

    case MimeTypes.doc:
    case MimeTypes.docx:
    case MimeTypes.gDoc:
    case MimeTypes.gFile:
    default:
      return DocIcon;
  }
};
